/**
 * 利用料金明細一覧の state。
 * 請求情報画面で月別明細一覧を表示したり、詳細画面で対象月を選ぶ基礎データとして使う。
 */
import { atom } from 'recoil';
import type { BillingDataList } from '@/types/api/customer/mercuryMypage';

/** 利用料金明細一覧取得APIの結果を保持する state。 */
const billingDataState = atom<BillingDataList>({
  key: 'billingDataState',
  default: {
    billing_list: [],
  },
});
export default billingDataState;
